<template>
  <div>
    <div v-if="is && billing">
      <div class="opc-cart__main__divider"></div>
      <div class="opc-cart-item__sub-title">{{ $t("billing.prorated.current_summary") }}</div>
      <div class="opc-cart-item__text">{{ billing.label }}: {{ $money(billing.amount) }}</div>
      <div class="opc-cart-item__text">
        {{ $t('billing.order_summary.extra_charges') }}
      </div>
      <div class="opc-cart-item__text text-capitalized">
        {{ this.$t('billing.order_summary.next_charge_date') }}: {{ billing.renewDate }}
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>
  
<script>
import mxCurrent from '../current.vue';
import { mapGetters } from 'vuex';
export default {
  mixins: [mxCurrent],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    is() {
      return false; // to be implemented
    },
    billing() {
      const billingCycle = this.getSelectedPlans[0]?.billing_cycle; // TODO multiple edit plans
      return this.billingCycleList.find((x) => x.billingCycle == billingCycle);
    },
  },
};
</script>